import React from 'react';
import { USER_IMPORT_ROW_STATUSES, UserImportRowStatusChip } from './UserImportRowStatusChip';

/**
 * The user import results table's columns, one row per spreadsheet row: its outcome, email,
 * name, the new user's id (created rows) and the reason it was skipped or failed.
 */
export const userImportResultColumns = [
	{
		field: 'status',
		headerName: 'Result',
		width: 120,
		hideable: false,
		valueFormatter: (value) => USER_IMPORT_ROW_STATUSES[value].label,
		renderCell: ({ value }) => <UserImportRowStatusChip status={value} />,
	},
	{ field: 'email', headerName: 'Email', flex: 1, minWidth: 200 },
	{ field: 'name', headerName: 'Name', flex: 1, minWidth: 160 },
	// Only created rows have one
	{ field: 'userId', headerName: 'User id', width: 220 },
	{ field: 'reason', headerName: 'Reason', flex: 2, minWidth: 260 },
];
